import * as React from 'react';
import { LinkButton, ArticleParagraph1, useDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IFileChoseProps {
  name: string;
  buttonText: string;
  descriptionText: string;
  multiple?: boolean;

  onFileSelect(files: FileList | null): void;
}
export const FileChose: React.FC<IFileChoseProps> = props => {
  const { onFileSelect, name, multiple, buttonText, descriptionText } = props;
  const isMobileView = useDeviceType() !== 'desktop';
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onFileSelect(e.target.files);
    },
    [onFileSelect],
  );

  return (
    <label className={styles['field']}>
      <div className={styles['action']}>
        <input
          name={name}
          className={styles['input']}
          type="file"
          onChange={handleChange}
          multiple={multiple}
          data-testid="file-chose"
        />
        <LinkButton theme="fill_secondary" size="M" fullWidth={isMobileView}>
          {buttonText}
        </LinkButton>
        {!isMobileView && (
          <div className={styles['description']}>
            <ArticleParagraph1>{descriptionText}</ArticleParagraph1>
          </div>
        )}
      </div>
    </label>
  );
};

FileChose.displayName = 'FileChose';
